import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';
import Select from 'react-select'
import PaletizadosTable  from "./PaletizadosTable"

export class PaletasBodegaView extends Component {
    constructor(props) {
        super(props);
        var rawUrl = window.location.toString();
        var semana_Id = rawUrl.split("Semanas/")[1].split("/")[0];
        this.state = {
            operation: props.operation,
            etiquetasCore: [],
            paletizados: [],
            proveedores: [],
        };
        if (props.data) {
            this.state.model = props.data;
            //this.state.model.fechaDeCosecha = new Date(this.state.model.fechaDeCosecha).toISOString().substring(0, 10);
            //this.state.model.fechaDeEmpaque = new Date(this.state.model.fechaDeEmpaque).toISOString().substring(0, 10);
        }
        else {
            this.state.model = {
                semana_Id: semana_Id,
                entrada: "",
                bodega: "",
                proveedor_Id: 0,
                paletizado_Id: 0,
                omitir: false,
            };
        }
        console.log(" this.state.model", this.state.model)
        this.state.modelValidation = {
            //vaporSemanal_Id: this.state.model.vaporSemanal_Id != 0,
            //paletizado_Id: this.state.model.destino_Id != 0,
            //contenedor_Id: this.state.model.contenedor_Id != 0,
            //etiquetaEspecial: this.state.model.etiquetaEspecial != "",
        }
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000);
        this.populateData = this.populateData.bind(this);
        this.load_proveedores = this.load_proveedores.bind(this);
        this.load_paletizados = this.load_paletizados.bind(this);
        this.table_onselect = this.table_onselect.bind(this);
    }

    async handleChange(event) {
        var value = event.target.value;
        if (event.target.name == "omitir") {
            value = value == "true";
        }
        var tempModel = this.state.model;
        tempModel[event.target.name] = value;
        this.setState({
            model: tempModel
        }, async () => {
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });

    }
    async validate() {
        const token = await authService.getAccessToken();
        var model = this.state.model;
        const data = JSON.stringify(model);
        const response = await fetch('api/paletasBodega/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }
    
    render() {
        return (
            <div >
                <Row>
                    <Form>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="archivo">
                                        <FormattedMessage id='Archivo' />
                                    </Label>
                                    <Input
                                        id="archivo"
                                        name="archivo"
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.model.archivo}
                                        readOnly
                                    />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="entrada">
                                        <FormattedMessage id='Entrada' />
                                    </Label>
                                    <Input
                                        id="entrada"
                                        name="entrada"
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.model.entrada}
                                        readOnly
                                    />
                                </FormGroup>
                            </Col>
                           
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="proveedor_Id">
                                        <FormattedMessage id='Proveedor' />
                                    </Label>
                                    <Input
                                        id="proveedor_Id"
                                        name="proveedor_Id"
                                        type="select"
                                        disabled
                                        onChange={this.handleChange}
                                    >
                                        <option value="0"></option>
                                        {this.state.proveedores.map(proveedor => proveedor.proveedor_Id == this.state.model.proveedor_Id ? (
                                            <option value={proveedor.proveedor_Id} selected>
                                                {proveedor.nombre + (proveedor.codigo_Productor !== null && proveedor.codigo_Productor !== '' ? " (" + proveedor.codigo_Productor + ")" : " (No valido)")}
                                            </option>
                                        ) : (<option value={proveedor.proveedor_Id}>{proveedor.nombre + (proveedor.codigo_Productor !== null && proveedor.codigo_Productor !== '' ? " (" + proveedor.codigo_Productor + ")" : " (No valido)")}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col className="col col-md-3">
                                <FormGroup>
                                    <Label for="omitir">
                                        <FormattedMessage id='Omitir' />
                                    </Label>
                                    <Input
                                        id="omitir"
                                        name="omitir"
                                        type="select"
                                        onChange={this.handleChange}
                                        value={this.state.model.omitir}
                                    >
                                        <option value={true} ><FormattedMessage id='Si' /></option>
                                        <option value={false} ><FormattedMessage id='No' /></option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col className="col col-md-3">
                                <FormGroup >
                                    <Label for="bodega">
                                        <FormattedMessage id='Bodega' />
                                    </Label>
                                    <Input
                                        id="bodega"
                                        name="bodega"
                                        //placeholder={placeholder}
                                        type="select"
                                        onChange={this.handleChange}
                                        value={this.state.model.bodega}
                                        valid={this.getValidationValue(this.state.modelValidation.bodega)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.bodega)}
                                    >
                                        <option></option>
                                        <option style={{ backgroundColor: '#2a9d8f' }}>1A</option>
                                        <option style={{ backgroundColor: '#2a9d8f' }}>1B</option>
                                        <option style={{ backgroundColor: '#2a9d8f' }}>1C</option>
                                        <option style={{ backgroundColor: '#2a9d8f' }}>1D</option>
                                        <option style={{ backgroundColor: '#2a9d8f' }}>1E</option>
                                        <option style={{ backgroundColor: '#2a9d8f' }}>1F</option>
                                        <option style={{ backgroundColor: '#e9c46a' }}>2A</option>
                                        <option style={{ backgroundColor: '#e9c46a' }}>2B</option>
                                        <option style={{ backgroundColor: '#e9c46a' }}>2C</option>
                                        <option style={{ backgroundColor: '#e9c46a' }}>2D</option>
                                        <option style={{ backgroundColor: '#e9c46a' }}>2E</option>
                                        <option style={{ backgroundColor: '#e9c46a' }}>2F</option>
                                        <option style={{ backgroundColor: '#f4a261' }}>3A</option>
                                        <option style={{ backgroundColor: '#f4a261' }}>3B</option>
                                        <option style={{ backgroundColor: '#f4a261' }}>3C</option>
                                        <option style={{ backgroundColor: '#f4a261' }}>3D</option>
                                        <option style={{ backgroundColor: '#f4a261' }}>3E</option>
                                        <option style={{ backgroundColor: '#f4a261' }}>3F</option>
                                        <option style={{ backgroundColor: '#e76f51' }}>4A</option>
                                        <option style={{ backgroundColor: '#e76f51' }}>4B</option>
                                        <option style={{ backgroundColor: '#e76f51' }}>4C</option>
                                        <option style={{ backgroundColor: '#e76f51' }}>4D</option>
                                        <option style={{ backgroundColor: '#e76f51' }}>4E</option>
                                        <option style={{ backgroundColor: '#e76f51' }}>4F</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="codigoTMU">
                                        <FormattedMessage id='Código TMU' />
                                    </Label>
                                    <Input
                                        id="codigoTMU"
                                        name="codigoTMU"
                                        type="text"
                                        disabled
                                        onChange={this.handleChange}
                                        value={this.state.model.codigoTMU}
                                        valid={this.getValidationValue(this.state.modelValidation.codigoTMU)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.codigoTMU)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col></Col>
                        </Row>
                        <Row>
                            <PaletizadosTable data={this.state.paletizados} table_onselect={this.table_onselect} />
                        </Row>
                        
                    </Form>
                </Row>
            </div>
        );
    }
    componentDidMount() {
        this.populateData();
    }
    async populateData() {
        await this.validate();
        this.setState({
            loading: true,
            //etiquetasCore: await this.load_etiquetasCore(),
            paletizados: await this.load_paletizados(),
            proveedores: await this.load_proveedores(),
        }, async () => {
            this.setState({loading: false });
        });
    }

    async load_etiquetasCore() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/etiquetasCore/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_paletizados() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/paletasBodega/PaletizadosSinVincular?semana_Id=' + this.state.model.semana_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_proveedores() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/proveedores/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async table_onselect(id) {
        console.log("table_onselect", id)
        const paletizado = this.state.paletizados.find((row) => row.paletizado_Id == id);
        console.log("paletizado", paletizado)
        var model = this.state.model;
        model.codigoTMU = paletizado.codigoTMU;
        model.proveedor_Id = paletizado.proveedor_Id
        this.setState({
            model: model
        }, await this.validate());
    };
}